import React, { Component } from 'react';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* Result */
import Result from 'iotera-base/result'

/* React Router */
import { withRouter } from 'react-router-dom'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'
import { actions as loadingActions } from '../../redux/ducks/loading'

/* Routes */
import { domainIsTenant as dit, S, domain } from '../../routes/routes'

/* Object Json */
import { isEmpty } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType, parse, stringify, size, clean } from 'iotera-base/json';

import { SubViewHeader } from '../../lib/components/subHeader';

import { Button, TextField, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

import { DialogVarAdd } from '../dashboard-add-component/dialog/var-add';
import { DialogVarList } from '../dashboard-add-component/dialog/var-list';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const INIT_DASHBOARD = "INIT_DASHBOARD";
const INIT_DASHBOARD_CURR = "INIT_DASHBOARD_CURR";
const EDIT = "EDIT";
const WKEY = "DASHBOARD_EDIT";
let wSelector = buildWSelector(WKEY)
let wBoundAction = buildWBoundActions(WKEY)

class DashboardEdit extends Component {
  constructor(props) {
    super(props);
    const dashboardId = safeDeepGet(this, ['props', 'match', 'params', 'id']);
    this.state = {
      loading: true,
      dashboardId
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const name = safeDeepGetWithType(event, ['target', 'name'], '')
    const value = safeDeepGet(event, ['target', 'value'], '')
    this.setState({ [name]: value })
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { dashboardId } = _state;
    // callback global
    setCallbackGlobal(_props)
    if (isEmpty(dashboardId)) {
      return;
    }
    const domainIsTenant = dit(_props);
    // Get dashboard
    _props.wInitRequestCall(
      {
        requests: {
          [INIT_DASHBOARD]: {
            wparam: { ...domainIsTenant, path: '/service/web/application/nav/get/id/' + dashboardId },
            wcallback: {
              started: function (id) {
                _props.showLoading();
              },
              finished: function (id, result) {
                if (result['code'] === 200) {
                } else {
                  _this.setState({ loading: false })
                }
                _props.hideLoading();
              }
            },
            wreducer: {
              rparse: function (id, result, rpayload) {
                let item = {};
                let dashboard = rpayload;
                let label = safeDeepGetWithType(dashboard, ['label'], '');
                let path = safeDeepGetWithType(dashboard, ['path'], '');
                let desc = safeDeepGetWithType(dashboard, ['desc'], '');
                let parent = safeDeepGetWithType(dashboard, ['parent'], '');
                let conf_dashboard = safeDeepGetWithType(dashboard, ['conf_dashboard'], {});
                let _var = safeDeepGetWithType(conf_dashboard, ['var'], {});
                let version = safeDeepGetWithType(conf_dashboard, ['version'], "2");
                let decimal = safeDeepGetWithType(conf_dashboard, ['view', 'decimal'], 2);
                let refresh = safeDeepGetWithType(conf_dashboard, ['config', 'refresh'], 0);
                refresh = '' + refresh;
                item.label = safeDeepGetWithType(dashboard, ['label'], '');
                if (desc === '') {
                  desc = null
                }
                item.desc = desc;
                item.dashboard = stringify(safeDeepGetWithType(dashboard, ['conf_dashboard'], {}));
                if (parent !== '') {
                  item.parent = parent;
                }
                clean(item)
                _this.setState({ loading: false, label, desc, version, _var, decimal, refresh, parent, path })
                return item;
              }
            }
          },
          [INIT_DASHBOARD_CURR]: {
            wparam: { ...domainIsTenant, path: '/service/web/application/nav/list/nin/' + dashboardId },
            wcallback: {
              started: function (id) {
                _props.showLoading();
              },
              finished: function (id, result) {
                if (result['code'] === 200) {
                }
                _props.hideLoading();
              }
            }
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [EDIT]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/nav/edit"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  const path = safeDeepGetWithType(result, ['body', 'path'], _this.state.path)
                  _props.showSingleNotification({ message: 'Edit Dashboard Sukses', level: 'success' });
                  _props.history.push('..' + S + '_dashboard_conf_' + S + path)
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Edit Dashboard Gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { dashboardId } = _state;
    if (isEmpty(dashboardId)) {
      return;
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  handleSubmit(event) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const label = safeDeepGetWithType(_state, ['label'], '');
    if (label === '') {
      _props.showSingleNotification({ message: 'Nama dashboard tidak boleh kosong', level: 'warning' });
      return;
    }
    const desc = safeDeepGet(_state, ['desc']);
    let parent = safeDeepGetWithType(_state, ['parent'], '');
    let refreshString = safeDeepGet(_state, ['refresh'])
    if (refreshString === '') {
      _props.showSingleNotification({ message: 'Refresh rate tidak boleh kosong!', level: 'error' });
      return;
    }
    let refresh = parseInt(refreshString);
    if (refresh !== 0 && refresh < 500) {
      _props.showSingleNotification({ message: 'Refresh rate harus lebih besar dari 500 (ms) atau 0 (untuk auto)!', level: 'error' });
      return;
    }
    const decimal = safeDeepGetWithType(_state, ['decimal'], 2);
    let _var = safeDeepGetWithType(_state, ['_var'], {});
    for (let key in _var) {
      delete _var[key]._varType;
    }
    let view = { decimal }
    let config = { refresh }
    clean(config)
    let varToShow = isEmpty(_var) ? "" : `, "var" : ${stringify(_var)}`
    let configToShow = isEmpty(config) ? "" : `, "config" : ${stringify(config)}`
    let dashboard = `{ "version" : "2", "view" : ${stringify(view)}${configToShow}${varToShow}}`
    let conf_dashboard = parse(dashboard)
    let dashboardBody = {
      label,
      conf_dashboard,
      parent,
      desc
    }
    clean(dashboardBody);
    const id = safeDeepGet(_state, ['dashboardId']);
    _this.setState({ loading: true });
    _props.wSingleRequestCall({
      id: EDIT,
      body: {
        id,
        ...dashboardBody
      }
    });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let label = safeDeepGetWithType(_state, ['label'], '')
    let desc = safeDeepGetWithType(_state, ['desc'], '')
    let refresh = safeDeepGetWithType(_state, ['refresh'], '0')
    let decimal = safeDeepGetWithType(_state, ['decimal'], 2)
    let parent = safeDeepGetWithType(_state, ['parent'], '')
    let varLocal = safeDeepGetWithType(_state, ['_var'], {})
    let varLocalLength = size(varLocal)
    let items = safeDeepGetWithType(_props, ['items'], {});
    let parentItems = []
    for (let keys in items) {
      let currItem = items[keys]
      parentItems.push(
        <MenuItem value={currItem.id}>{currItem.label}</MenuItem>
      )
    }
    if (parentItems.length > 0) {
      parentItems = [<MenuItem key={null} value={null}><em>None</em></MenuItem>].concat(parentItems)
    }
    const refreshInt = parseInt(refresh)
    let errorRefresh = (refreshInt !== 0 && refreshInt < 500) || isNaN(parseInt(refresh))
    let refreshHelper = 'Refresh rate dalam satuan milisecond (ms), akan di-set auto jika refresh rate = 0'
    if (errorRefresh) {
      refreshHelper = 'Refresh rate harus merupakan angka >= 500 atau 0'
    }
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Edit Dashboard' subTitle='Formulir Edit Dashboard' />
          <div className="io-container mt-12">
            <form>
              <FormControl style={{ minWidth: '100%' }} >
                <TextField
                  label="Nama Dashboard"
                  value={label}
                  autoFocus
                  required
                  onChange={_this.handleChange}
                  type="string"
                  margin='dense'
                  inputProps={{ name: "label" }}
                />
              </FormControl>
              <FormControl style={{ minWidth: '100%' }} >
                <TextField
                  label="Deskripsi Dasboard"
                  value={desc}
                  onChange={_this.handleChange}
                  type="string"
                  margin='dense'
                  inputProps={{ name: "desc" }}
                />
              </FormControl>
              <FormControl style={{ minWidth: '45%', marginRight: 10 }} >
                <TextField
                  error={errorRefresh}
                  label="Refresh Rate"
                  value={refresh}
                  onChange={_this.handleChange}
                  type="number"
                  margin='dense'
                  inputProps={{ name: "refresh", min: "500", step: "1" }}
                  helperText={refreshHelper}
                />
              </FormControl>
              <FormControl required style={{ minWidth: '45%', marginRight: 10, marginTop: 5 }}>
                <InputLabel>Desimal yang akan ditampilkan</InputLabel>
                <Select
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  value={decimal}
                  onChange={_this.handleChange}
                  inputProps={{
                    name: 'decimal'
                  }}
                >
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>0.1</MenuItem>
                  <MenuItem value={2}>0.01</MenuItem>
                  <MenuItem value={3}>0.001</MenuItem>
                  <MenuItem value={4}>0.0001</MenuItem>
                  <MenuItem value={5}>0.00001</MenuItem>
                </Select>
              </FormControl>
              {parentItems.length > 0 &&
                <FormControl style={{ minWidth: '100%' }} >
                  <InputLabel>Parent</InputLabel>
                  <Select
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    value={parent}
                    onChange={_this.handleChange}
                    inputProps={{
                      name: 'parent'
                    }}
                  >
                    {parentItems}
                  </Select>
                </FormControl>
              }
              <DialogVarList _parent={_this} isGlobal={true} />
              <DialogVarAdd _parent={_this} />
              <div className='row' style={{ minWidth: '100%', marginTop: 10 }} >
                <div className='col-md-6' style={{ marginTop: 10 }}>
                  <span>
                    {varLocalLength > 0 &&
                      <Button variant="outlined" type="button"
                        onClick={(e) => _this.setState({ dialogListVar: true, hasAction: true })}
                        style={{ marginRight: 10 }} >List Variabel</Button>
                    }
                    <Button variant='outlined' color='primary'
                      onClick={(e) => _this.setState({ dialogAddVar: true })} >Tambah Variabel</Button>
                  </span>
                </div>
                <div className='col-md-6 button-right' style={{ marginTop: 10 }}>
                  <Button variant="outlined" type="button" size="large" style={{ minWidth: '0%' }}
                    onClick={(e) => _props.history.goBack()} >Batal</Button>
                  <Button variant="contained" size="large" color="primary" onClick={_this.handleSubmit}
                    style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state, ownProps) {
  return {
    item: wSelector.getMappedRPayload(state, INIT_DASHBOARD),
    items: wSelector.getMappedRPayload(state, INIT_DASHBOARD_CURR, 'navs')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundAction(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
    ...bindActionCreators(loadingActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardEdit));